module.exports = __webpack_public_path__ + "static/Remohab_EN-c23f3dea11d2aec312344cb1955371d1.mp4";